import { Clear, ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Hidden,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Paper, Toolbar } from "ui";
import {
  setActiveReplaceLists,
  StoredReplaceList,
  useReplaceList,
} from "./replace-list-store";
import { useState } from "react";

export default function ReplaceListPriority() {
  const { t } = useTranslation();

  return (
    <Paper md={12} sm="auto">
      <Hidden mdDown>
        <Toolbar>
          <Typography variant="h6">{t("Replace list prio")}</Typography>
        </Toolbar>
        <Box marginTop={1}>
          <DragableListOrder />
        </Box>
      </Hidden>
      <Hidden mdUp>
        <Accordion disableGutters>
          <Toolbar>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6">{t("Replace list prio")}</Typography>
            </AccordionSummary>
          </Toolbar>
          <AccordionDetails>
            <DragableListOrder />
          </AccordionDetails>
        </Accordion>
      </Hidden>
    </Paper>
  );
}

function DragableListOrder() {
  const { t } = useTranslation();
  const activeLists = useReplaceList((state) => state.activeLists);

  const [drag, setDrag] = useState<StoredReplaceList | null>(null);
  const [dragOver, setDragOver] = useState<StoredReplaceList | null>(null);

  const handleDrag = (
    e: React.DragEvent<HTMLTableRowElement>,
    list: StoredReplaceList
  ) => {
    e.stopPropagation();
    e.preventDefault();
    setDrag(list);
  };

  const handleDragOver = (
    e: React.DragEvent<HTMLTableRowElement>,
    list: StoredReplaceList
  ) => {
    e.stopPropagation();
    e.preventDefault();
    setDragOver(list);
  };

  const handleDrop = (e: React.DragEvent<HTMLTableRowElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (drag && dragOver && drag !== dragOver) {
      setActiveReplaceLists(
        activeLists.map((current) =>
          current._id === drag?._id
            ? dragOver
            : current._id === dragOver?._id
            ? drag
            : current
        )
      );
    }
    setDrag(null);
    setDragOver(null);
  };

  return (
    <>
      {activeLists.length === 0 ? (
        <Box padding={2}>
          <Typography variant="body2">{t("No active lists")}</Typography>
        </Box>
      ) : (
        <TableContainer>
          <Table size="medium">
            <TableBody>
              {activeLists.map((list) => {
                return (
                  <TableRow
                    key={list._id}
                    hover
                    draggable="true"
                    onDrag={(e) => handleDrag(e, list)}
                    onDragOver={(e) => handleDragOver(e, list)}
                    onDrop={(e) => handleDrop(e)}
                    style={{ cursor: "pointer" }}
                  >
                    <TableCell>{list.name}</TableCell>
                    <TableCell padding="none" width={60}>
                      <IconButton
                        onClick={() =>
                          setActiveReplaceLists(
                            activeLists.filter(
                              (active) => active._id !== list._id
                            )
                          )
                        }
                        size="small"
                      >
                        <Clear />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
